<template>
  <div id="app">
    <Loader></Loader>
    <router-view />
  </div>
</template>

<script>
export default {
  async beforeMount() {
    await this.$store.dispatch('CHECK_TOKEN_APP')
    this.$store.commit('loadingFail')
    console.log('checked mounted')
  }
}
</script>
<style lang="scss">
</style>
